module.exports = __webpack_public_path__ + "img/history_icon.445e4ac5.svg";